"use client";

import { useBillingProfileGate } from "~/billing-profile/hooks/useBillingProfileGate";
import { BillingProfileGateModal } from "./BillingProfileGateModal";

/**
 * FEAT-087: wrapper que monta el modal bloqueante de BillingProfile cuando aplica.
 *
 * Pensado para montarse una sola vez a nivel global (en `providers.tsx`) y
 * decidir client-side si renderiza el modal en base a `useBillingProfileGate`.
 */
export function BillingProfileGate(): JSX.Element | null {
  const { shouldShowGate } = useBillingProfileGate();

  if (!shouldShowGate) return null;

  return <BillingProfileGateModal />;
}
